import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';

import './hsr-element.scss';

interface IProps {
  charClass: string;
}

export const HSRPath: React.FC<IProps> = ({ charClass }) => {
  const popoverElement = (
    <Popover id="popover-element">
      <Popover.Header as="h3">{charClass}</Popover.Header>
      <Popover.Body>
        {charClass === 'Destruction' && (
          <span>
            Deal outstanding amounts of <strong>damage</strong> and possess
            great <strong>survivability</strong>. Suitable for various combat
            scenarios.
          </span>
        )}
        {charClass === 'Hunt' && (
          <span>
            Deal extraordinary amounts of <strong>single-target damage</strong>.
            The main damage dealers against Elite Enemies.
          </span>
        )}
        {charClass === 'Erudition' && (
          <span>
            Deal remarkable amounts of <strong>multi-target damage</strong>. The
            main damage dealers against groups of enemies.
          </span>
        )}
        {charClass === 'Harmony' && (
          <span>
            Apply <strong>buffs</strong> to allies to improve the team's combat
            capacities.
          </span>
        )}
        {charClass === 'Nihility' && (
          <span>
            Apply <strong>debuffs</strong> to enemies to reduce their combat
            capacities.
          </span>
        )}
        {charClass === 'Preservation' && (
          <span>
            Possess powerful <strong>defensive</strong> abilities to protect
            allies in various ways.
          </span>
        )}
        {charClass === 'Abundance' && (
          <span>
            <strong>Heal</strong> allies and restore HP to the team.
          </span>
        )}
      </Popover.Body>
    </Popover>
  );
  return (
    <OverlayTrigger
      trigger="click"
      rootClose
      placement="auto-start"
      overlay={popoverElement}
    >
      <div className={`hsr-path ${charClass}`}>
        {charClass === 'Destruction' && (
          <StaticImage
            src="../../../../images/starrail/icons/path_destruction.png"
            alt={charClass}
          />
        )}
        {charClass === 'Hunt' && (
          <StaticImage
            src="../../../../images/starrail/icons/path_hunt.png"
            alt={charClass}
          />
        )}
        {charClass === 'Erudition' && (
          <StaticImage
            src="../../../../images/starrail/icons/path_erudition.png"
            alt={charClass}
          />
        )}
        {charClass === 'Harmony' && (
          <StaticImage
            src="../../../../images/starrail/icons/path_harmony.png"
            alt={charClass}
          />
        )}
        {charClass === 'Nihility' && (
          <StaticImage
            src="../../../../images/starrail/icons/path_nihility.png"
            alt={charClass}
          />
        )}
        {charClass === 'Preservation' && (
          <StaticImage
            src="../../../../images/starrail/icons/path_preservation.png"
            alt={charClass}
          />
        )}
        {charClass === 'Abundance' && (
          <StaticImage
            src="../../../../images/starrail/icons/path_abundance.png"
            alt={charClass}
          />
        )}
        {charClass === 'Remembrance' && (
          <StaticImage
            src="../../../../images/starrail/icons/path_remem.png"
            alt={charClass}
          />
        )}
        <span>{charClass}</span>
      </div>
    </OverlayTrigger>
  );
};
